import React from "react";

const IconImport = (props) => {
  const { size = 20, ...rest } = props;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...rest} viewBox="0 0 16 16" fill="currentColor">
      <path d="M7.33317 10.6667V5.23341L5.59984 6.96675L4.6665 6.00008L7.99984 2.66675L11.3332 6.00008L10.3998 6.96675L8.6665 5.23341V10.6667H7.33317ZM3.99984 13.3334C3.63317 13.3334 3.31928 13.2029 3.05817 12.9417C2.79706 12.6806 2.6665 12.3667 2.6665 12.0001V10.0001H3.99984V12.0001H11.9998V10.0001H13.3332V12.0001C13.3332 12.3667 13.2026 12.6806 12.9415 12.9417C12.6804 13.2029 12.3665 13.3334 11.9998 13.3334H3.99984Z" fill="currentColor"/>
    </svg>
  );
};

export default IconImport;